<template>
    <div class="sidebar-container">
        <vtk-sidebar-item title="Arquivos"
            ><div
                v-for="(vtkFile, index) in vtkFiles"
                :key="vtkFile.name"
                :class="{
                    'sidebar-file-item': true,
                    'second-sidebar-file-item': index > 0
                }"
            >
                <b-input-group>
                    <b-input-group-prepend is-text>
                        <b-form-radio
                            v-model="activeVtkFileIndex"
                            switch
                            class="mr-n2"
                            name="active-vtk-file"
                            :value="index"
                            :disabled="busy"
                        />
                    </b-input-group-prepend>
                    <b-form-input disabled :value="vtkFile.simpleTitle" />
                    <b-input-group-append is-text>
                        <b-form-checkbox
                            switch
                            class="mr-n2"
                            :checked="vtkItems[index].isVisible"
                            :disabled="busy"
                            @input="changeVisibility(index, $event)"
                        />
                    </b-input-group-append>
                </b-input-group></div
        ></vtk-sidebar-item>
        <vtk-sidebar-item
            title="Representação"
            item-class="sidebar-item sidebar-item-representation"
            ><swx-dropdown
                v-model="representation"
                block
                variant="outline-primary"
                :options="representationOptions"
                :disabled="busy"
        /></vtk-sidebar-item>
        <vtk-sidebar-item-variables
            item-class="sidebar-item sidebar-item-representation"
            :vtk-item="activeVtkItem"
            :vtk-file="vtkFiles[activeVtkFileIndex]"
            :busy="busy"
            @changeColorBy="changeColorBy"
        />
        <vtk-sidebar-item
            title="Ferramentas"
            item-class="sidebar-item sidebar-item-tools"
        >
            <b-button
                v-b-tooltip.hover.top="'Reiniciar câmera'"
                variant="outline-primary"
                :disabled="busy"
                @click="$emit('resetCamera')"
                ><i class="fas fa-redo"
            /></b-button>
            <b-button
                v-b-tooltip.hover.top="'Inverter cores da legenda'"
                variant="outline-primary"
                :disabled="busy"
                @click="$emit('revertTransferFunctions', activeVtkItem)"
                ><i class="fas fa-adjust"
            /></b-button>
        </vtk-sidebar-item>
    </div>
</template>

<script>
import SwxDropdown from "@/components/SwxDropdown";
import VtkSidebarItem from "./VtkSidebarItem";
import VtkSidebarItemVariables from "./VtkSidebarItemVariables";

export default {
    name: "VtkSidebar",
    components: {
        SwxDropdown,
        VtkSidebarItem,
        VtkSidebarItemVariables
    },
    props: {
        vtkFiles: {
            type: Array,
            required: true
        },
        vtkItems: {
            type: Array,
            required: true
        },
        busy: {
            type: Boolean,
            required: true
        },
        allowedRepresentations: {
            type: Array,
            default() {
                return ["Surface", "Surface With Edges", "Wireframe"];
            }
        }
    },
    data() {
        return {
            activeVtkFileIndex: 0
        };
    },
    computed: {
        activeVtkItem() {
            return this.vtkItems[this.activeVtkFileIndex];
        },
        representation: {
            get() {
                return this.activeVtkItem.representation;
            },
            set(representation) {
                this.$emit(
                    "changeRepresentation",
                    this.activeVtkFileIndex,
                    representation
                );
            }
        },
        representationOptions() {
            return this.activeVtkItem.representationList
                .filter(rep => this.allowedRepresentations.includes(rep))
                .map(rep => ({
                    value: rep,
                    text: rep
                }));
        }
    },
    methods: {
        changeColorBy(colorBy) {
            this.$emit("changeColorBy", {
                index: this.activeVtkFileIndex,
                ...colorBy
            });
        },
        changeVisibility(index, isVisible) {
            this.$emit("changeVisibility", { index, isVisible });
        }
    }
};
</script>

<style lang="scss" scoped>
$vtk-sidebar-width: 285px;

.sidebar-container {
    min-width: $vtk-sidebar-width;
    max-width: $vtk-sidebar-width;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.sidebar-file-item {
    /deep/ {
        .input-group-text {
            border-radius: 0;
        }

        .input-group-prepend > .input-group-text {
            border-left: none;
            background-color: transparent;
        }

        .input-group-append > .input-group-text {
            border-right: none;
            background-color: transparent;
        }

        .form-control {
            background-color: transparent !important;
        }
    }
}

.second-sidebar-file-item {
    /deep/ {
        .input-group-text,
        .form-control {
            border-top: none;
        }
    }
}

.sidebar-item-representation {
    /deep/ {
        .dropdown-toggle {
            border-radius: 0;
            border-left: none;
            border-right: none;
            border-color: #ced4da;
        }
        .dropdown-menu {
            width: $vtk-sidebar-width;
            border-radius: 0;
        }
    }
}

.sidebar-item-tools {
    text-align: center;
    /deep/ {
        .btn:not(:last-child) {
            margin-right: 1rem;
        }
    }
}
</style>
